/// <reference path="util.ts" />

var authTokenService = (function () {
    var authHeaderName = 'X-AuthBearer';

    function getAuthHeaderName() {
        return authHeaderName;
    }

    function getAuthTokenFromLocalStorage() {
        if (window.localStorage) {
            try {
                var stJson = localStorage.getItem("securityToken");
                var rc = stJson && stJson.length > 0 && stJson != 'undefined' ? JSON.parse(stJson) : null;
                if (rc && rc.SecurityToken) {
                    return rc.SecurityToken;
                } else {
                    return "";
                }
            }
            catch (err) {
                localStorage.setItem("securityToken", "");
            }
        }
    }

    return {
        getUserToken: getAuthTokenFromLocalStorage,
        getAuthHeaderName: getAuthHeaderName
    };

})();

var authCommonResponse = (function () {
    var $window = window;

    var redirectToLogout = function () {
        $window.location = ResolveUrl('~/Initial/Logout.aspx');
    };

    var validateResponse = function (response) {
        if (response.status === 401) {
            redirectToLogout();
        }

        var responseData = response.data || response.d;
        if (responseData) {
            var data = responseData.d || responseData;
            var statusCode = ((data || {}).Error || {}).ResponseStatusCode;
            if (statusCode === 401) {
                redirectToLogout();
            }
        }
    };

    var getResponseData = function (response, angularWindow) {
        try {
            if (angularWindow) { $window = angularWindow; }
            validateResponse(response);
            var commonResponseResult = GetCommonResponseResult(response);
            if (commonResponseResult == null) {
                return response;
            } else {
                if (response.d) {
                    response.d = commonResponseResult;
                } else {
                    response.data.d = commonResponseResult;
                }
                return response;
            }
        } catch (error) {
            return response;
        }
    };

    var GetCommonResponseResult = function (response) {
        var result = GetCommonResponseDataResult(response);
        var originalTypeOfResultWasAList = GetOriginalTypeOfResultWasAList(response);

        if (result && originalTypeOfResultWasAList == true) {
            return result;
        } else if (result && originalTypeOfResultWasAList == false) {
            return result[0] || [];
        } else {
            return null;
        }
    };

    var GetCommonResponseDataResult = function (response) {
        var responseData = response.data || response.d;
        responseData = responseData.d || responseData;
        return (responseData || {}).Result;
    };

    var GetOriginalTypeOfResultWasAList = function (response) {
        var originalTypeOfResultWasAList = ((response.data || {}).d || {}).OriginalTypeOfResultWasAList;

        if (originalTypeOfResultWasAList == null || originalTypeOfResultWasAList === 'undefined') {
            return false;
        } else {
            return originalTypeOfResultWasAList;
        }
    };

    return {
        get: getResponseData,
        validate: validateResponse
    };

})();